import { render, staticRenderFns } from "./CheckEmail.vue?vue&type=template&id=71fa3b24&"
import script from "./CheckEmail.vue?vue&type=script&lang=js&"
export * from "./CheckEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports